type BasePerson = Record<
  'fullName' | 'position' | 'avatar' | 'linkedIn',
  string
>;

type Person = BasePerson & {
  quoteI18nKeys: Record<string, string>;
};

export const TRACY_CHEA: Person = {
  fullName: 'Tracy Chea',
  position: 'position.Sales_Engineer',
  avatar: '/redesign/images/personas/Tracy_Chea.webp',
  linkedIn: 'https://www.linkedin.com/in/tracychea/',
  quoteI18nKeys: {
    careers: 'quotes.tracy-chea.careers',
  },
};

export const ALEXANDER_ZHIVITSKY: Person = {
  fullName: 'Alexander Zhivitsky',
  position: 'position.PPC_Manager',
  avatar: '/redesign/images/personas/Alexander_Zhivitsky.webp',
  linkedIn: 'https://www.linkedin.com/in/alexzhivitsky/',
  quoteI18nKeys: {
    careers: 'quotes.alex-zhivitsky.careers',
  },
};

export const DANIEL_FRIED: Person = {
  fullName: 'Daniel Fried',
  position: 'position.Senior_VP_of_Sales_EMEA',
  avatar: '/redesign/images/personas/Daniel_Fried.webp',
  linkedIn: 'https://www.linkedin.com/in/danielfried/',
  quoteI18nKeys: {
    careers: 'quotes.daniel-fried.careers',
  },
};
